export default {
    posts: [],

    activePost:null,

    managePostDialog:false

}